
import ApiService from "@/core/services/ApiService";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { Modal } from "bootstrap";
import moment from "moment";
import pdfMake from "pdfmake";
import { Field } from "vee-validate";
import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Multiselect from "@vueform/multiselect";

export default defineComponent({
  name: "view-detail-invoice",
  components: {
    Field,
    Loading,
    pdfMake,
    Multiselect,
  },
  props: {
    widgetClasses: String,
  },

  data() {
    return {
      isLoading: false,
      fullPage: true,
      isColor: "#007BFF",
      isBackgroundColor: "#A3A3A3",
      isOpacity: 0.5,
      imageFotoBank: "",
      Data: <any>[],
      detail: <any>[],
      role: "",
      listBank: <any>[],
      listBankOtomatis: <any>[],
      listBankManual: <any>[],
      showExpVaNumber: "",
      dataPayment: <any>{},
      selectBank: <any>{
        bankAccountNumber: "",
        bankAccountName: "",
      },
      listcoa: <any>[],
      dataConfig: <any>{},
      book: <any>{},
      paymentStatusInit: false,
      expDate: 0,
      showFormCoa: false,
      sumber: "",
      checkDataPayment: <any>{},
      bankManual: "",
      targetKonfirmasi: <any>{
        rekTujuan: "",
      },
      balanceCoa: 0,
      joinInvoice: false,
      tutorial: "",
      previewPembayaranSingle: false,
      showtutorial: false,
      error1: {
        selectBank1: "Pilih Bank Pembayaran",
      },
      error2: {
        selectBank2: "Pilih Sumber Dana",
      },
      showForm: false,
      statusModalBayarSinglePaid: false,
      poolings: false,
      statusModalBayarSingleVa: false,
      showVaName: "",
      showVaBank: "",
      doSubmit: true,
      showVaNumber: "",
      totalAmount: 0,
      Idinvoice: "",
      alertChange: "",
      tipeBayarManualSingle: false,
      buttonBayarManualSingle: true,
      resultBayarManual: false,
      errorBayarManual: {
        namaPengirim: "",
        noRef: "",
        penanggungJawab: "",
      },
      errorBayarManualSingle: {
        namaPengirim: "",
        noRef: "",
        penanggungJawab: "",
      },
      modalOpen: false,
      isExpired: 0,
      skipStatus: false,
    };
  },

  async beforeMount() {
    store.dispatch(Actions.VERIFY_AUTH_FINANCE);
    this.role = JSON.parse(localStorage.getItem("user_account")!).role;
    if (this.$route.params._id != "multi-invoice") {
      this.getIdInvoices();
      await this.cekStatus();
      this.getListBank("AUTOMATIC", "");
      this.getListBank("MANUAL", "");
      this.getcombocoa(this.$route.params._id);
    } else {
      this.getDataCache();
    }
  },

  watch: {
    listBank(newVal, oldVal) {
      if (newVal.length == 0) return;
      this.isLoading = true;
      let data = newVal.find((item) => {
        const name = item.name || item.bankName;
        const bankName =
          this.dataPayment?.data?.vaBank || this.dataPayment?.data?.bankName;
        return (
          name == bankName && item.bankType == this.dataPayment?.paymentMethod
        );
      });
      this.selectBank = data || {
        bankAccountNumber: "",
        bankAccountName: "",
      };
      this.isLoading = false;
      let val = this.Data.vaBank?.toUpperCase();
      this.handleImage(val);
    },
    dataPayment(newVal, oldVal) {
      if (this.listBank.length == 0) return;
      this.isLoading = true;
      let data = this.listBank.find((item) => {
        const name = item.name || item.bankName;
        const bankName =
          this.dataPayment?.data?.vaBank || this.dataPayment?.data?.bankName;
        return name == bankName && item.bankType == newVal?.paymentMethod;
      });
      this.selectBank = data || {
        bankAccountNumber: "",
        bankAccountName: "",
      };
      this.isLoading = false;
      let val = this.Data.vaBank?.toUpperCase();
      this.handleImage(val);
    },
  },

  methods: {
    handleImage(val) {
      switch (val) {
        case "NTB SYARIAH":
        case "BANK NTB SYARIAH":
          this.imageFotoBank = "/media/bank/bank_ntbs.png";
          break;
        case "BNI":
          this.imageFotoBank = "/media/bank/bank_bni.png";
          break;
        case "BRI":
        case "BANK BRI":
          this.imageFotoBank = "/media/bank/bank_bri.png";
          break;
        case "BSI-SBI":
        case "BSI":
        case "XENDIT BSI":
          this.imageFotoBank = "/media/bank/bank_bsi.png";
          break;
        case "BANK JATIM SYARIAH":
        case "BANKJATIM":
          this.imageFotoBank = "/media/bank/bank_jatim_syariah.png";
          break;
        case "MANDIRI":
          this.imageFotoBank = "/media/bank/bank_mandiri.png";
          break;
        case "PERMATA":
          this.imageFotoBank = "/media/bank/bank_permata.png";
      }
    },
    getBankIcon(val) {
      let img = "";
      val = val.toUpperCase();
      switch (val) {
        case "NTB SYARIAH":
        case "BANK NTB SYARIAH":
          img = "/media/bank/bank_ntbs.png";
          break;
        case "BNI":
          img = "/media/bank/bank_bni.png";
          break;
        case "BRI":
        case "BANK BRI":
          img = "/media/bank/bank_bri.png";
          break;
        case "BSI-SBI":
        case "BSI":
        case "XENDIT BSI":
          img = "/media/bank/bank_bsi.png";
          break;
        case "BANK JATIM SYARIAH":
        case "BANKJATIM":
          img = "/media/bank/bank_jatim_syariah.png";
          break;
        case "MANDIRI":
          img = "/media/bank/bank_mandiri.png";
          break;
        case "PERMATA":
          img = "/media/bank/bank_permata.png";
      }
      return img;
    },
    skip() {
      this.dataPayment.paymentMethod = "MANUAL";
      this.skipStatus = true;
      this.printpreview();
    },
    clickReset() {
      // this.getData(this.paging.size, this.paging.page);
      this.book.invoice = [];
      this.skipStatus = false;
      this.book.bankName = "";
      this.book.sumberdana = "";
      this.error1.selectBank1 = "";
      this.error2.selectBank2 = "";
      this.totalAmount = 0;
      this.book.nomorRekening = "";
      this.bankManual = "";
      this.alertChange = "Metode Pembayaran Berhasil Dipilih";
      this.paymentStatusInit = false;
      this.balanceCoa = 0;
      this.dataPayment = {
        paymentId: "",
        paymentMethod: "",
        paymentStatus: "",
        vaName: "",
        vaBank: "",
        showExpVaNumber: "",
        vaNumber: "",
        item: "",
      };
      this.checkDataPayment = {
        data: {
          callbacks: [{ coaCode: "" }],
          vaBank: "",
        },
      };
      this.book.metodeName = "Otomatis";
      this.book.sumberdana = "";
      this.showFormCoa = false;
      this.balanceCoa = 0;
      this.bankManual = "";
      this.targetKonfirmasi.rekTujuan = "";
      this.book.bankName = "";
      this.targetKonfirmasi = {
        id: "",
        namaPengirim: "",
        rekTujuan: "",
        persetujuanFinance: "",
        rekPengirim: "",
        tanggal: "",
        note: "",
        paymentId: "",
        noRef: "",
        penanggungJawab: "",
        namaRektujuan: "",
        paidAmount: 0,
        imageBuktiTF: "",
        imageBuktiTFRslt: "",
      };
      this.expDate = 0;
      this.showExpVaNumber = "";
      this.Idinvoice = "";
      this.modalOpen = false;
      this.joinInvoice = false;
      this.getIdInvoices();
      this.cekStatus();
    },
    bayarManualSingle(e) {
      if (e == "Otomatis") {
        var modal = new Modal(document.getElementById("modal-payment"));
        modal.show();
        this.paymentByID();
      } else {
        this.tipeBayarManualSingle = true;
        this.buttonBayarManualSingle = false;
        this.errorBayarManual.namaPengirim = "";
        this.errorBayarManual.noRef = "";
        this.errorBayarManual.penanggungJawab = "";
        this.resultBayarManual = false;
        this.targetKonfirmasi.namaPengirim = "";
        this.targetKonfirmasi.noRef = "";
        this.targetKonfirmasi.penanggungJawab = "";
        this.targetKonfirmasi.namaRektujuan = this.returnAcontName(
          this.checkDataPayment.data?.vaBank
        );
        this.targetKonfirmasi.rekTujuan = this.returnBankName(
          this.checkDataPayment.data?.vaBank
        );
        var modal2 = new Modal(document.getElementById("modal-payment"));
        modal2.hide();
        const modal = new Modal(
          document.getElementById("kt_modal_konfirm_manual")
        );
        modal.show();
      }
    },
    getTutorial(sd) {
      var a = "";
      this.listBank.forEach((element: any) => {
        // if (this.book.metodeName == "Manual")
        if (element.bankName == sd) a = element.tutorial;
        else if (element.bankCode == sd) a = element.tutorial;
      });
      if (a == "" || a == null) this.showtutorial = false;
      else this.showtutorial = true;
      this.tutorial = a;
    },
    getbalance(val) {
      const toast = useToast();
      ApiService.getWithoutSlug(
        `crmv2/main_invoice/invoice/office/invoice/coa/balance/${this.Data.schoolId}?coaCode=${val}`
      )
        .then(({ data }) => {
          if (data.balance < this.totalAmount && !this.showFormCoa) {
            var message = `Saldo Coa ${this.book.sumberdana} tidak cukup untuk pembayaran invoice`;
            this.book.sumberdana = "";
            this.balanceCoa = 0;
            return toast.error(message);
          }
          this.balanceCoa = data.balance;
        })

        .catch((error) => {});
    },
    changeMetode(prop) {
      var metode = prop.target.value == "Manual" ? "MANUAL" : "AUTOMATIC";
      this.bankManual = "";
      this.book.bankName = "";
    },
    async paymentByID(isGenerate = false) {
      var metode = this.book.metodeName;
      const toast = useToast();
      this.book.metodeName = metode;
      if (!this.doSubmit) return;
      if (this.book.sumberdana == "")
        this.error2.selectBank2 = "Sumber Dana Harus Diisi";
      if (this.book.bankName == "")
        this.error1.selectBank1 = "Bank Harus Diisi";
      if (!isGenerate) {
        if (this.sumber == "Topup Manual" && this.book.bankName == "")
          return toast.error("Form Kosong wajib diisi");
        if (this.showFormCoa === true) this.book.sumberdana = "";
        if (
          this.sumber == "Topup Manual" &&
          this.balanceCoa < this.totalAmount &&
          !this.showFormCoa
        ) {
          var message = `Saldo Coa${this.book.sumberdana}tidak cukup untuk pembayaran invoice`;
          this.book.sumberdana = "";
          return toast.error(message);
        }
      }
      if (this.book.bankName == "")
        this.error1.selectBank1 = "Bank Harus Diisi";
      else {
        this.isLoading = true;
        const metod = metode == "Otomatis" ? "AUTOMATIC" : "MANUAL";
        var url = "crmv2/main_invoice/invoice/office/invoice/pay";
        if (this.role !== "SUPER_ADMIN")
          url = "crmv2/main_invoice/invoice/invoice/pay";
        url = `${url}?bankName=${this.book.bankName}&invoiceId=${this.$route.params._id}&paymentMethod=${metod}&coaCode=${this.book.sumberdana}`;
        try {
          let response = await ApiService.postWithoutSlug(url);
          var urlrole_cekpayment_ =
            this.role == "SUPER_ADMIN"
              ? "crmv2/main_invoice/invoice/office/invoice"
              : "crmv2/main_invoice/invoice/invoice";
          let responseData = await ApiService.getWithoutSlug(
            `${urlrole_cekpayment_}/payment_data/${this.$route.params._id}`
          );
          this.checkDataPayment = responseData.data;
          this.book.preview = response.data;
          this.dataPayment.paymentMethod = this.checkDataPayment.paymentMethod;
          this.dataPayment.paymentStatus = this.checkDataPayment.paymentStatus;
          if (metod == "MANUAL") {
            this.targetKonfirmasi.id = responseData.data.data.invoiceId;
            this.statusModalBayarSingleVa = true;
            this.showVaName = response.data.vaName;
            this.showVaBank = response.data.vaBank;
            this.targetKonfirmasi.paidAmount = response.data.totalAmount;
            this.targetKonfirmasi.persetujuanFinance =
              response.data.paymentStatus;
            this.targetKonfirmasi.paymentId = response.data.paymentId;
            this.showVaNumber = response.data.vaNumber;
            this.showExpVaNumber = response.data.expiredDate;
          } else {
            this.previewPembayaranSingle = false;
            this.dataPayment.vaName = this.checkDataPayment.data?.vaName || "";
            this.dataPayment.vaBank = this.checkDataPayment.data?.vaBank || "";
            this.dataPayment.vaNumber =
              this.checkDataPayment.data?.vaNumber || "";
            this.showExpVaNumber = response.data.expiredDate;
            this.expDate =
              new Date(response.data.expiredDate).getTime() - Date.now();
            toast.success(this.alertChange);
          }
          this.skipStatus = false;
          this.isExpired = 0;
          await this.getIdInvoices();
          await this.cekStatus();
          this.printpreview(true);
        } catch (error) {
        } finally {
          this.isLoading = false;
          this.error1.selectBank1 = "";
          this.error2.selectBank2 = "";
        }
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatDateTime(value) {
      return moment(value).format("DD MMMM YYYY HH:mm");
    },
    changebankManual(e) {
      this.listBankManual.forEach((element: any, idx) => {
        if (element.bankName === e.target.value) {
          this.targetKonfirmasi.rekTujuan = element.bankAccountNumber;
          this.targetKonfirmasi.namaRektujuan = element.bankAccountName;
          this.book.bankName = element.bankName;
        }
      });
      this.getTutorial(e.target.value);
    },
    returnBankName(e) {
      var data = "";
      this.listBank.forEach((element: any) => {
        if (element.bankName === e) data = element.bankAccountNumber;
      });
      return data;
    },
    returnAcontName(e) {
      var data = "";
      this.listBank.forEach((element: any) => {
        if (element.bankName === e) data = element.bankAccountName;
      });
      return data;
    },
    getcombocoa(val) {
      if (val) {
        ApiService.getWithoutSlug(
          `crmv2/main_invoice/invoice/office/invoice/coa/combo_coa/${val}`
        ).then(({ data }) => {
          this.listcoa = data;
        });
      }
    },
    getListBank(e, va) {
      ApiService.getWithoutSlug(`crmv2/main_bank/bank/payment/type/${e}`)
        .then((resp) => {
          if (e == "AUTOMATIC") this.listBankOtomatis = resp.data;
          else this.listBankManual = resp.data;
          this.listBank = [...this.listBankOtomatis, ...this.listBankManual];
        })
        .catch((err) => {
          this.listBank = [];
        });
    },
    getIdInvoices() {
      this.isLoading = true;
      const toast = useToast();
      const $route = useRoute();
      ApiService.getWithoutSlug(
        "crmv2/main_invoice/invoice/office/invoice/" + this.$route.params._id
      )
        .then((data) => {
          this.Data = data.data;
          switch (data.data.vaBank) {
            case "NTB SYARIAH":
              this.imageFotoBank = "/media/bank/bank_ntbs.png";
              break;
            case "BNI":
              this.imageFotoBank = "/media/bank/bank_bni.png";
              break;
            case "BRI":
              this.imageFotoBank = "/media/bank/bank_bri.png";
              break;
            case "BSI-SBI":
            case "XENDIT BSI":
              this.imageFotoBank = "/media/bank/bank_bsi.png";
              break;
            case "BANKJATIM":
              this.imageFotoBank = "/media/bank/bank_jatim_syariah.png";
              break;
            case "MANDIRI":
              this.imageFotoBank = "/media/bank/bank_mandiri.png";
              break;
            case "PERMATA":
              this.imageFotoBank = "/media/bank/bank_permata.png";
          }
          this.detail = data.data.detail;
          this.isLoading = false;
        })
        .catch((_e) => {
          this.isLoading = false;
        });
    },

    getDataCache() {
      this.isLoading = true;
      const array = JSON.parse(localStorage.getItem("listDetailInv")!);
      this.Data = array;
      this.detail = array.detail;
      this.isLoading = false;
    },

    printpreview(isPrint = false) {
      console.log(this.Data.joinInvoice, "joinInvoice");
      let modalName = "kt_modal_print";
      if (
        (this.isExpired < 0 && this.skipStatus != true) ||
        this.dataPayment?.paymentMethod == "" ||
        this.dataPayment?.paymentMethod == null
      )
        modalName = "modal-payment";
      if (
        isPrint ||
        (this.dataPayment?.paymentMethod == "MANUAL" && !this.Data.joinInvoice)
      )
        modalName = "kt_modal_print";
      console.log(this.dataPayment?.paymentMethod);
      const modal = new Modal(document.getElementById(modalName));
      modal.show();
    },

    printpdf() {
      var printContents = document.getElementById("capturepdf")!.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      location.reload();
    },

    formatDate(value) {
      return moment(value).format("L");
    },

    cekNull(value) {
      if (value) return value;
      else return "-";
    },

    async cekStatus() {
      var urlrole = "crmv2/main_invoice/invoice/office/invoice";
      if (
        !(
          this.role == "SUPER_ADMIN" ||
          this.role == "SALES_AREA" ||
          this.role == "SALES_LEADER"
        )
      )
        urlrole = "crmv2/main_invoice/invoice/invoice";
      try {
        let responseWait = await ApiService.getWithoutSlug(
          `${urlrole}/wait/${this.$route.params._id}`
        );
        let responseData = await ApiService.getWithoutSlug(
          `${urlrole}/payment_data/${this.$route.params._id}`
        );
        this.isExpired = moment(responseData.data.data.expiredDate).diff(
          moment(),
          "days"
        );
        this.dataPayment = responseData.data;
        this.dataConfig = {
          book: responseData.data,
          status: responseWait.data,
        };
      } catch (error) {}
    },
    changeBank(event) {
      this.dataPayment.paymentId = "";
      this.dataPayment.paymentMethod = "";
      this.dataPayment.paymentStatus = "";
      this.dataPayment.vaName = "";
      this.dataPayment.vaBank = "";
      this.dataPayment.vaNumber = "";
      this.dataPayment.item = "";
      this.checkDataPayment = {
        data: {
          callbacks: [{ coaCode: "" }],
          vaBank: "",
        },
      };
      this.book.metodeName = "Otomatis";
      if (this.joinInvoice) this.book.metodeName = "Manual";
      this.book.sumberdana = "";
      this.balanceCoa = 0;
      this.bankManual = "";
      this.targetKonfirmasi.rekTujuan = "";
      this.book.bankName = "";
      var modal = new Modal(document.getElementById("modal-payment"));
      modal.show();
    },
  },
});
